import * as React from 'react';
import { useSelector } from 'react-redux';

import { Logo } from '../../components/Logo';
import { IApplicationState } from '../../types/redux';
import { useApplicationContext } from '../../utils/applicationContext';

export function LogoContainer() {
  const {
    custom: { mainPageUrl },
  } = useApplicationContext();

  const noResize = useSelector((state: IApplicationState) => state.noResize);

  return <Logo noResize={noResize} url={mainPageUrl} />;
}
